import React, {
  FC, useState, ChangeEvent, useEffect, useMemo
} from 'react';
import {
  DialogTitle,
  DialogContent,
  IconButton,
  Box,
  Button,

} from '@mui/material';
import { RiCloseLine, RiFilter3Fill } from 'react-icons/ri';
import { FilterBar } from 'views/rebranded-module/tours-module/ToursListingViewV2/components/FilterBar';
import StyledBox, {
  StyledDialog,
} from 'views/rebranded-module/tours-module/ToursListingViewV2/components/ResponsiveFilterBar/ResponsiveFilterBar.styles';
import { Typography700 } from 'views/common/components';
import { useContent } from 'views/rebranded-module/common/context/useContent';
import { FILTER_TYPES } from 'views/rebranded-module/tours-module/ToursListingViewV2/utils/constants';



const ResponsiveFilterBar: FC<any> = (props) => {
  const [openFilterDialog, setOpenFilterDialog] = useState(false);
  const cmsData = useContent('ToursListingPage');
  const durations = cmsData.durationsList;
  const {
    countries = [],
    regions = [],
    tours = [],
    tourType,
    filters,
    handleFilterChange,
    toursCount,
    toursList,
  } = props;
const durationsWithStatus = useMemo(() => {
  if (!durations || !toursList?.length) return durations;
  const availableDurations = toursList.map((tour) => tour.days_count);
return durations.map((d) => {
    const hasMatch = availableDurations.some(
      (days) => days >= d.from && days <= d.to
    );
    return {
      ...d,
      disabled: !hasMatch,
    };
  });
}, [durations, toursList]);

  // Add "All" options to the filter lists
  const countriesWithAll = useMemo(() => [
    { id: 'all', name: cmsData.allCountriesLabel, slug: null,  value: 'all' },
    ...(countries || [])
  ], [countries, cmsData.allCountriesLabel]);

  const regionsWithAll = useMemo(() => [
    { id: 'all', name: cmsData.allStatesLabel, slug: null,  value: 'all' },
    ...(regions || [])
  ], [regions, cmsData.allStatesLabel]);

  const filtersLists = [
    {
      id: FILTER_TYPES.TOUR,
      title: cmsData.allTourTypesLabel,
      menuTitle: cmsData.allTourTypesLabel,
      list: tours,
      selectedValue: tourType,
      valueKey: 'value',
      type: FILTER_TYPES.TOUR,
      accordionTitle: tours.find((tourItem) => tourItem.value === tourType)
        ?.name,
    },
    {
      id: FILTER_TYPES.COUNTRY,
      title: cmsData.allCountriesLabel,
      menuTitle: cmsData.allCountriesLabel,
      list: countriesWithAll,
     selectedValue: filters.country || cmsData.allCountriesLabel,
      type: FILTER_TYPES.COUNTRY,
    },
    {
      id: FILTER_TYPES.REGION,
      title: cmsData.allStatesLabel,
      menuTitle: cmsData.allStatesLabel,
      list: regionsWithAll,
      selectedValue: filters.region || cmsData.allStatesLabel,
      type: FILTER_TYPES.REGION,
      disabled: !filters.country,

    },
    {
        id: FILTER_TYPES.DURATION,
        title: durations.find(d => d.id === filters.duration)?.name || cmsData.anyDurationLabel,
        menuTitle: cmsData.anyDurationLabel,
        list: durationsWithStatus,
        selectedValue: filters.duration ?? durations[0]?.id,
        valueKey: 'id',                                   
        type: FILTER_TYPES.DURATION,
        disabled: toursCount === 0,
    },
    ];
 
  const handleOpenFilterDialog = () => {
    setOpenFilterDialog(true);
    sessionStorage.setItem('tourListingFilterDialog', 'true');
  };
  const handleCloseFiltertDialog = () => {
    setOpenFilterDialog(false);
    sessionStorage.removeItem('tourListingFilterDialog');
  };
  useEffect(() => {
    const isDialogOpen = sessionStorage.getItem('tourListingFilterDialog') === 'true';
    if (isDialogOpen) {
      setOpenFilterDialog(true);
    }
  }, []);
  return (
    <StyledBox>
      {/* Desktop filter bar visible only on md and up */}
      <Box className="showDESKTOP">
        <FilterBar
          flitersList={filtersLists}
          handleChange={(e: ChangeEvent<HTMLInputElement>, type) => handleFilterChange(e.target.value, type)}
        />
      </Box>

      {/* Mobile filter button and dialog */}
      <Box className="showTABLET">
        <Box className="RFBActionWrapper">
          <Button
            variant="contained"
            fullWidth
            size="large"
            onClick={handleOpenFilterDialog}
            startIcon={<RiFilter3Fill />}
          >
            {cmsData.filterBtnLabel}
          </Button>
        </Box>

        <StyledDialog
          open={openFilterDialog}
          onClose={handleCloseFiltertDialog}
          fullScreen
        >
          <DialogTitle>
            <IconButton
              edge="end"
              color="inherit"
              onClick={handleCloseFiltertDialog}
              className="RFBClose"
              aria-label="close"
            >
              <RiCloseLine />
            </IconButton>
            <Typography700 variant="h7">
              {cmsData.searchToursOverlatTitle}
            </Typography700>
          </DialogTitle>
          <DialogContent>
            <FilterBar
              flitersList={filtersLists}
              handleChange={(e: ChangeEvent<HTMLInputElement>, type) => handleFilterChange(e.target.value, type)}
              handleSearchBtnClick={handleCloseFiltertDialog}
            />
          </DialogContent>
        </StyledDialog>
      </Box>
    </StyledBox>
  );
};

export { ResponsiveFilterBar };
